import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时更新的人气排行，看看大家都在看什么
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 md:gap-5 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-bold text-sm">
                {item.rank <= 3 ? (
                  <span
                    className={`w-full h-full flex items-center justify-center rounded-lg text-background-50 font-bold text-sm ${
                      item.rank === 1
                        ? 'bg-accent-500'
                        : item.rank === 2
                          ? 'bg-primary-500'
                          : 'bg-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-foreground-400 font-bold text-sm">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 px-2 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-700">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 truncate">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5">
                <span className="text-xs text-accent-500 font-medium">
                  {item.change === 'new' ? (
                    <span className="flex items-center gap-0.5">
                      <i className="ri-sparkling-line"></i>
                      新
                    </span>
                  ) : (
                    <i className="ri-arrow-up-fill"></i>
                  )}
                </span>
                <span className="text-xs text-foreground-400 font-medium">
                  {item.hot.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}